import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { mediaMinWidth } from 'themes/mixins/mediaQueries';

import { Headline } from 'components/Headline';

const Wrapper = styled.div`
  padding: 2.5rem 0;

  border-bottom: 0.1rem solid ${pickColor('gray')};

  ${mediaMinWidth.md(css`
    padding: 1.2rem 0;
  `)}
`;

const Inner = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Container = styled.div`
  align-self: flex-end;
`;

const Title = styled(Headline)`
  font-family: 'LFT Zeno Condensed', sans-serif;
  text-transform: uppercase;

  letter-spacing: 0.1rem;
`;

const GridButtons = styled.div``;

export { Wrapper, Container, Inner, GridButtons, Title };
